module.exports = __webpack_public_path__ + "static/media/close-white.6ae0f9af.svg";